import React from "react";
import Header from "components/Common/Header/Header";
import AppUserMedicalBody from "components/AppUserComponents/AppUserDetails/AppUserMedical/AppUserMedicalBody";

const AppUserMedical = () => {
  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="appuser" />
      <AppUserMedicalBody />
    </main>
  );
};

export default AppUserMedical;
